import React from 'react';
import { FormikProps } from 'formik';
import { FormField } from '../../../../../global/components/form-element/form-field';
import { DomesticPartnerWizard } from '../wizard/domestic-partner-wizard';
import { DomesticPartnerFormAction } from '../model/domestic-partner-form-models';


interface Props {
	formProps: FormikProps<any>;
	wizard: DomesticPartnerWizard;
}
export function DomesticPartnerAgreements(props: Props) {
	const {
		formProps,
		wizard,
	} = props;

	if (!formProps?.values?.formAction) {
		return null;
	}

	return (
		<>
			<FormField
				name='checkbox1'
				label={wizard?.getCheckBox1Text()}
				component='checkBox'
				touched={formProps.touched}
				errors={formProps.errors}
				value={formProps?.values?.checkbox1 ?? false}
				checked={formProps?.values?.checkbox1 ?? false}
			/>
			{
				formProps?.values?.formAction !== DomesticPartnerFormAction.DEATH &&
				(
					<FormField
						name='checkbox2'
						label={wizard?.getCheckBox2Text()}
						component='checkBox'
						touched={formProps.touched}
						errors={formProps.errors}
						value={formProps?.values?.checkbox2 ?? false}
						checked={formProps?.values?.checkbox2 ?? false}
					/>
				)
			}
		</>
	);
}